export enum AuthAction {
    Login,
    Logout
}